import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata,
  columns,
  searchBy,
  onDateChange,
  selectedDate,
}) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [filters, setFilters] = useState({
    hub: "",
  });

  useEffect(() => {
    let filtered = apidata;

    // 🔍 Search
    if (dataFilter) {
      filtered = filtered.filter((item) =>
        item[searchBy]?.toLowerCase().includes(dataFilter.toLowerCase()),
      );
    }

    // 📍 Hub
    if (filters.hub) {
      filtered = filtered.filter((item) => item.hub === filters.hub);
    }

    setFilteredData(filtered);
  }, [dataFilter, apidata, filters]);

  const applyFilters = (newFilters) => {
    setFilters(newFilters);
    setShowFilterModal(false);
  };

  const removeFilters = () => {
    setFilters({ leasing_partner: "", hub: "" });
    setShowFilterModal(false);
  };

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-3">
          <input
            type="text"
            placeholder={`Search by ${searchBy}`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        <div className="col-md-9">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover
        noDataComponent={<p>No data found</p>}
      />

      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        apidata={apidata}
        onDateChange={onDateChange}
        selectedDate={selectedDate}
      />
    </>
  );
}
